import React, { useState } from 'react';
import { Bot, downloadContactsCSV, downloadGroupsCSV } from "../bot-loaders";
import { SavingButton } from '../components/SavingButton';

export function DownloadContactButton({bot}:{bot:Bot}){
    const [loading, setLoading] = useState(false);
    const [file, setFile] = useState("");

    async function download(){
        if(loading) return;
        setLoading(true)
        try {
            let csv = await downloadContactsCSV(bot);
            setFile(csv)
        }catch(e){
            console.error(e);
        }
        setLoading(false);
    }

    if(file)
        return <a download={`${bot.name}.csv`} href={`data:text/csv;charset=utf-8;base64,${file}`} className='btn btn-info me-2 mb-2'><i className='fa fa-save me-2'></i>Salvar Arquivo</a>

    return <SavingButton className='btn btn-primary me-2 mb-2' onClick={download} saving={loading} icon='fa-download'>{loading ? 'Preparando Arquivo...' : 'Salvar Contatos'}</SavingButton>
    
}

export function DownloadGroupsButton({bot}:{bot:Bot}){
    const [loading, setLoading] = useState(false);
    const [file, setFile] = useState("");

    async function download(){
        if(loading) return;
        setLoading(true)
        try {
            let csv = await downloadGroupsCSV(bot);
            setFile(csv)
        }catch(e){
            console.error(e);
        }
        setLoading(false);
    }

    if(file)
        return <a download={`${bot.name}.zip`} href={`data:application/zip;charset=utf-8;base64,${file}`} className='btn btn-info mb-2 me-2'><i className='fa fa-save me-2'></i>Salvar Arquivo</a>

    return <SavingButton className='btn btn-info mb-2 me-2' onClick={download} saving={loading} icon='fa-download'>{loading ? 'Preparando Arquivo...' : 'Salvar Grupos'}</SavingButton>
    
}